module.exports = __webpack_public_path__ + "img/qr2.7c71608c.png";